import { Controller } from '@hotwired/stimulus'
import { headers } from '../../src/js/csrf'

export default class extends Controller {
  static targets = [ 'likeButton' ]

  // action
  like() {
    const toggleClasses = () => {
      this.likeButtonTarget.classList.toggle('fa-heart_default')
      this.likeButtonTarget.classList.toggle('fa-heart_favorited')
    }
    let request
    if (this.likeButtonTarget.dataset.favoritesFavoriteId) {
      const favoriteId = this.likeButtonTarget.dataset.favoritesFavoriteId
      request = new Request('/favorites/' + favoriteId, {
        method: 'delete',
        headers: headers
      })
      fetch(request)
      // better to check if response ok
      .then(() => {
        delete this.likeButtonTarget.dataset.favoritesFavoriteId
        toggleClasses()
      }).catch(error => console.error("we got an error:", error))
    } else {
      request = new Request('/favorites', {
        method: 'post',
        headers: headers,
        body: JSON.stringify({
          favoritable_id: this.data.get('objectId'),
          favoritable_type: this.data.get('objectType')
        })
      })
      fetch(request)
      .then(response => {
        if (!response.ok) { throw response } // moving flow to catch block
        return response.json()
      }).then(data => {
        this.likeButtonTarget.dataset.favoritesFavoriteId = data.id
        toggleClasses()
      }).catch(error => console.error("we got an error:", error))
    }
  }
}
